import { createStore } from 'owa-satcheljs';
import type { AsyncItemRegistry } from 'owa-copilot-async-chat-types';
import type { AccountKey } from 'owa-client-types';

export interface AsyncItemRegistryStore {
    // Keyed by AccountKey from getAccountKeyForMailboxInfo(mailboxInfo).
    registryByAccount: Map<AccountKey, AsyncItemRegistry>;
}

export const getStore: () => AsyncItemRegistryStore = createStore<AsyncItemRegistryStore>(
    'asyncItemRegistryStore',
    {
        registryByAccount: new Map<AccountKey, AsyncItemRegistry>(),
    }
);
